import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatRadioChange } from '@angular/material/radio';
import { Subject, Subscription } from 'rxjs';
import { FilterSearch, FilterSingleChoice } from '../../../lib/model/Filter';
import { FilterService } from '../../../lib/services/filter.service';

@Component({
  selector: 'app-filter-single-choice',
  templateUrl: './filter-single-choice.component.html',
  styleUrls: ['./filter-single-choice.component.scss']
})
export class FilterSingleChoiceComponent implements OnInit, OnDestroy {
  /**
   * Subscription to filter service to auto update the filter upon request.
   */
  private filterServiceSubscription: Subscription;
  /**
   * The filter to initialize the component with.
   */
  @Input() filter: FilterSingleChoice;
  /**
   * Emit the filter upon update.
   */
  @Output() filterUpdated: EventEmitter<FilterSingleChoice> = new EventEmitter();

  constructor(private filterService: FilterService) { }

  ngOnInit() {
    this.filterServiceSubscription = this.filterService.filterSubject.subscribe((filter) => {
      if (filter.id === this.filter.id) {
        this.filter = <FilterSingleChoice>filter;
        this.filterUpdated.emit(this.filter);
      }
    });
  }

  ngOnDestroy() {
    this.filterServiceSubscription.unsubscribe();
  }

  toggleVisibility() {
    this.filter.visible = !this.filter.visible;
  }

  updateSelected(id: string, $event: any) {
    this.filter.value = id;
    this.filterUpdated.emit(this.filter);
  }
}
